export default __webpack_public_path__ + "static/media/1138.278ca448.png";